import SkeletonElement from "./SkeletonElement";

/**
 * Props for TabsSkeleton component
 * @param tabCount - Number of tabs to display (default: 3)
 * @param className - Additional CSS classes
 */
type TabsSkeletonProps = {
  tabCount?: number;
  className?: string;
};

export default function TabsSkeleton({ tabCount = 3, className = "" }: TabsSkeletonProps) {
  return (
    <div
      className={`mt-8 flex border-b border-sys-brand-outline-variant overflow-x-auto ${className}`}
      data-testid="tabs-skeleton"
    >
      {Array.from({ length: tabCount }).map((_, index) => (
        <SkeletonElement key={index} height="h-6" width="w-24" className="mb-4 mr-6" />
      ))}
    </div>
  );
}
